import styled from 'styled-components';
import { CouponRibbon } from 'components/ProductDetails/ProductDetails.styles';

export const OrderSummaryContainer = styled.div`
  background: ${({ theme }) => theme.palette.white};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-sizing: border-box;
  padding: 20px;
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 1.2rem;
  margin-bottom: 15px;
`;

export const CartItemsContainer = styled.div``;

export const CouponCode = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0px;
  & input[type='text'] {
    border: 1px solid red;
  }
`;

export const SubTotal = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
  margin: 10px 0px;
  div:nth-of-type(1) {
    font-weight: 400;
    color: rgba(0, 0, 0, 0.63);
  }
  div:nth-of-type(2) {
    font-weight: 500;
    color: rgba(0, 0, 0, 0.93);
  }
`;

export const Discount = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px 0px;
  color: #649942;
  font-weight: 500;
`;

export const Total = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 10px 0px;
  font-size: 1.5rem;
  font-weight: 500;
`;

export const Separator = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.08);
`;

export const LineItemsContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.up('md')} {
    overflow: scroll;
    max-height: 400px;
  }
`;

export const LineItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LineItemImage = styled.div`
  min-width: 25%;
`;

export const LineItemDescription = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 50%;
`;

export const ItemName = styled.div`
  font-weight: 500;
  font-size: 0.9rem;
`;

export const Quantity = styled.div`
  font-weight: 400;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.44);
`;

export const LineItemPrice = styled.div`
  min-width: 25%;
  text-align: right;
`;

export const PercentageOff = styled.div`
  color: #388e3c;
`;

export const CouponCodeContainer = styled.div`
  display: flex;
  padding: 10px 0px;
  justify-content: space-between;
`;
export const CouponCodeWrapper = styled.div`
  width: 70%;
`;

export const SummaryCouponRibbon = styled(CouponRibbon)`
  &::after {
    border-right: 13px solid #fff;
  }
`;

export const SubscriptionDetails = styled(Quantity)`
  color: #649942;
`;

export const TotalSaving = styled.div``;
